import * as React from "react";
import type { SVGProps } from "react";
const SvgExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.05 4.675a.375.375 0 0 0-.375.375v5.31a.375.375 0 0 0 .75 0V5.946l4.67 4.679a.375.375 0 1 0 .53-.53l-4.66-4.67h4.395a.375.375 0 0 0 0-.75zm8.315 8.68a.375.375 0 0 1 .53 0l4.67 4.679V13.62a.375.375 0 0 1 .75 0v5.31a.375.375 0 0 1-.375.375h-5.31a.375.375 0 0 1 0-.75h4.396l-4.661-4.67a.375.375 0 0 1 0-.53"
    />
  </svg>
);
export default SvgExpand;
